import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {
    IDatiqInputValidatorService,
    IDatiqValidatorsMap
} from '../models';

@Injectable({
    providedIn: 'root',
})
export class DatiqValidatorsRegisterService {
    private _validatorServices$: BehaviorSubject<
        IDatiqValidatorsMap
    > = new BehaviorSubject<IDatiqValidatorsMap>({});

    constructor() {}

    register(key: string, service: IDatiqInputValidatorService): void {
        const validatorServices: IDatiqValidatorsMap = this.getValidators();

        this._validatorServices$.next({
            ...validatorServices,
            [key]: service,
        });
    }

    getValidatorService(key: string): IDatiqInputValidatorService {
        const validatorServices: IDatiqValidatorsMap = this.getValidators();
        return validatorServices[key];
    }

    hasValidatorService(key: string): boolean {
        return !!this.getValidators()[key];
    }

    getValidators(): IDatiqValidatorsMap {
        return { ...this._validatorServices$.getValue() };
    }
}
